import React from 'react';

import Button, { ButtonProps } from 'components/Shared/Button/Button';
import Spinner from 'components/Shared/Spinner/Spinner';
import { colors } from 'styles/cp';

type ProgressButtonProps = ButtonProps & {
  spinner?: boolean;
  spinnerWidth?: number;
  hideContentOnSpinner?: boolean;
  onBlur?: React.FocusEventHandler<HTMLButtonElement>;
  onFocus?: React.FocusEventHandler<HTMLButtonElement>;
  onMouseDown?: React.MouseEventHandler<HTMLButtonElement>;
};

const ProgressButton = (props: ProgressButtonProps): React.ReactElement => {
  const {
    buttonType = 'default',
    contentColor,
    children = null,
    size = 'standard',
    spinner,
    spinnerWidth,
    hideContentOnSpinner = false,
    customizations = {},
    ...restProps
  } = props;

  let spinnerColor = contentColor;
  if (!spinnerColor && spinner) {
    switch (buttonType) {
      case 'default':
        spinnerColor = colors.gray;
        break;
      case 'tertiary':
        spinnerColor = colors.intuit_blue;
        break;
      default:
        spinnerColor = colors.white;
    }
  }
  let spinnerSize = spinnerWidth;
  if (!spinnerSize && spinner) {
    switch (size) {
      case 'mini':
        spinnerSize = 13;
        break;
      case 'medium':
        spinnerSize = 20;
        break;
      default:
        spinnerSize = 25;
    }
  }
  return (
    <Button {...restProps} buttonType={buttonType} size={size} customizations={customizations}>
      <span className="progress-btn-w">
        {spinner && (
          <span className="spinner">
            <Spinner
              width={spinnerSize}
              strokeWidth={5}
              color={spinnerColor}
              bgColor={colors.transparent}
              aria-label="Spinner"
            />
          </span>
        )}
        {!(hideContentOnSpinner && spinner) && children}
      </span>

      <style jsx>{`
        .progress-btn-w {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          width: 100%;
          line-height: 20px;
          .spinner {
            margin-right: ${hideContentOnSpinner ? '0px' : '5px'};
          }
        }
      `}</style>
    </Button>
  );
};

export default ProgressButton;
